import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-role-sidebar',
  templateUrl: './role-sidebar.component.html',
  styleUrls: ['./role-sidebar.component.scss']
})
export class RoleSidebarComponent implements OnInit {
  @Input() public roles: { name: string; description: string }[];

  @Input() public selected: string[] = [];
  @Output() public selectedChange = new EventEmitter<string[]>();

  public roleSearch = '';

  public get filteredRoles() {
    if (!this.roleSearch || !this.roleSearch.length) {
      return this.roles;
    }
    return this.roles.filter(r => r.name.startsWith(this.roleSearch));
  }

  constructor() {}

  ngOnInit(): void {}

  public selectAll() {
    this.selectedChange.emit(this.roles.map(r => r.name));
  }

  public selectNone() {
    this.selected = [];
    this.selectedChange.emit([]);
  }

  public isSelected(role: string): boolean {
    return this.selected.includes(role);
  }

  public toggleSelected(role: string) {
    // ensure a copy of the array is emitted to enforce an angular update
    const update = this.selected.slice();
    const index = this.selected.indexOf(role);
    if (index < 0) {
      update.push(role);
    } else if (this.selected.length >= 1) {
      update.splice(index, 1);
    }
    this.selected = update;
    this.selectedChange.emit(update);
  }
}
